// extracted by mini-css-extract-plugin
export default {"desktopFilters":"_2iDyZ","desktopFilters__heading":"_2v8rn","filterText":"_2mXuR","link":"BmwSM","filters__collapsible":"BGfpM"};